import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// Los <input type="number"> cambian de valor con la rueda del mouse (si el
// campo queda enfocado) y con las flechas arriba/abajo del teclado -- en un
// sistema de montos de dinero eso es peligroso (un scroll de página de más
// cambia la cifra sin que se note). Se desactivan los dos acá, una sola vez
// para toda la app, en vez de tocar cada input uno por uno.
document.addEventListener('wheel', () => {
  if (document.activeElement?.type === 'number') document.activeElement.blur();
}, { passive: true });
document.addEventListener('keydown', (e) => {
  if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') && e.target?.type === 'number') e.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
